import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'ukho-error',
    standalone: true,
    imports: [RouterLink],
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss']
})
export class ErrorComponent {}
